import React, { useEffect } from 'react';
import styles from './admin.module.css';
import { hasAdminAccess } from '../../api/api';
import { Route, Routes } from 'react-router-dom';
import { Snackbar } from '../../components/Snackbar/SnackbarContext';
import MeetingHome from '../meeting/MeetingHome';
import EvaluationDashboard from '../evaluation/EvaluationDashboard';
import { EvaluationReportPage } from '../evaluation/components/EvaluationReportPage';
import { CallLogs } from '../meeting/meeting-report/CallLogs';
import { TopAppBar } from '../app/app-nav/TopAppBar';

function EvaluationCallLogsWrapper() {
  return (
    <CallLogs
      reportUrlPath={(mid, page, reportId) => `/admin/evaluation-report/${mid}/${page}/${reportId}`}
    />
  );
}

export function AdminApp() {
  useEffect(() => {
    hasAdminAccess().then(response => {
      if (!response?.success) {
        window.location.href = '/';
      }
    });
  }, []);

  return (
    <div className={styles.app}>
      <Snackbar>
        <TopAppBar />
        <div className={styles.container}>
          <Routes>
            {/* Home - Assistants list */}
            <Route path="/" element={<MeetingHome />} />
            {/* Evaluation Routes - more specific routes first */}
            <Route
              path="/evaluation-report/:meetingId/:pageParam/:reportId"
              element={<EvaluationReportPage />}
            />
            <Route
              path="/evaluations/:meetingId/calls/:pageParam?"
              element={<EvaluationCallLogsWrapper />}
            />
            <Route path="/evaluations/:meetingId" element={<EvaluationDashboard />} />
            <Route path="/evaluations" element={<EvaluationDashboard />} />
          </Routes>
        </div>
      </Snackbar>
    </div>
  );
}
